// Wait for DrawerModal to be available
function defineQuoteRequestDrawer() {
  if (typeof DrawerModal === 'undefined') {
    // DrawerModal not yet available, wait a bit and try again
    setTimeout(defineQuoteRequestDrawer, 100);
    return;
  }

  if (!customElements.get("quote-request-drawer")) {
    customElements.define(
      "quote-request-drawer",
      class QuoteRequestDrawer extends DrawerModal {
      constructor() {
        super();
      }

      connectedCallback() {
        super.connectedCallback?.();
        this.form = this.querySelector("#QuoteRequestForm");
        this.quantityInput = this.querySelector("#quote-quantity-input");
        this.quantityMinus = this.querySelector("#quote-quantity-minus");
        this.quantityPlus = this.querySelector("#quote-quantity-plus");
        this.messageField = this.querySelector("#quote-request-message");
        
        this.setupQuantityInput();
        this.setupFormSubmission();
      }

      open(opener) {
        super.open(opener);
        this.populateProductInfo();
      }

      populateProductInfo() {
        // Get product information from the page
        const productInfo = this.getProductInfo();
        
        if (!productInfo) {
          console.error("Product information not found");
          return;
        }

        // Update product image
        const productImage = this.querySelector("#quote-product-image");
        if (productImage && productInfo.image) {
          productImage.src = productInfo.image;
          productImage.alt = productInfo.name;
        }

        // Update product name
        const productName = this.querySelector("#quote-product-name");
        if (productName) {
          productName.textContent = productInfo.name;
        }

        // Update product rating if available
        const productRating = this.querySelector("#quote-product-rating");
        if (productRating && productInfo.rating) {
          productRating.innerHTML = productInfo.rating;
        }

        // Update hidden fields
        const productIdField = this.querySelector("#quote-product-id");
        const variantIdField = this.querySelector("#quote-variant-id");
        const productNameField = this.querySelector("#quote-product-name-field");
        
        if (productIdField) productIdField.value = productInfo.id;
        if (variantIdField) variantIdField.value = productInfo.variantId;
        if (productNameField) productNameField.value = productInfo.name;

        // Set minimum quantity if available
        if (productInfo.minQuantity) {
          const minQuantityEl = this.querySelector("#quote-minimum-quantity");
          const minQuantityValue = this.querySelector("#quote-minimum-value");
          if (minQuantityEl) minQuantityEl.style.display = "block";
          if (minQuantityValue) minQuantityValue.textContent = productInfo.minQuantity.toLocaleString();
          if (this.quantityInput) {
            this.quantityInput.min = productInfo.minQuantity;
            if (parseInt(this.quantityInput.value) < productInfo.minQuantity) {
              this.quantityInput.value = productInfo.minQuantity;
            }
          }
        }

        // Variant options (e.g. Size, Color): read-only display and hidden field for submission
        const variantOptionsEl = this.querySelector("#quote-variant-options");
        const variantOptionsText = this.querySelector("#quote-variant-options-text");
        const variantOptionsField = this.querySelector("#quote-variant-options-field");
        if (variantOptionsEl && variantOptionsText && variantOptionsField && productInfo.variantOptions && productInfo.variantOptions.length > 0) {
          const parts = productInfo.variantOptions.map((o) => `${o.name}: ${o.value}`);
          const text = parts.join(" \u2013 ");
          variantOptionsText.textContent = text;
          variantOptionsField.value = text;
          variantOptionsEl.style.display = "block";
        } else if (variantOptionsEl && variantOptionsField) {
          variantOptionsEl.style.display = "none";
          variantOptionsField.value = "";
        }
      }

      getProductInfo() {
        // Try to get product info from various sources on the page
        const productForm = document.querySelector("product-form form");
        if (!productForm) return null;

        const variantId = productForm.querySelector('input[name="id"]')?.value;
        const productTitle = document.querySelector(".product-info-heading, h1")?.textContent?.trim();
        const productId = window.lastViewedProductId || productForm.dataset.productId;

        // Get product image
        let productImage = null;
        const featuredImage = document.querySelector(".product-media-main img, .product-media img");
        if (featuredImage) {
          productImage = featuredImage.src.split("&width=")[0] + "&width=200";
        }

        // Get product rating if available
        let rating = null;
        const ratingElement = document.querySelector(".product-rating-widget, .product-info-meta-item.last");
        if (ratingElement) {
          rating = ratingElement.innerHTML;
        }

        const variantOptions = this.getVariantOptions(productForm);

        return {
          id: productId,
          variantId: variantId,
          name: productTitle || "Product",
          image: productImage,
          rating: rating,
          minQuantity: 5000, // Default minimum, can be made configurable
          variantOptions: variantOptions
        };
      }

      getVariantOptions(productForm) {
        const options = [];
        const scope = productForm && productForm.ownerDocument ? productForm.ownerDocument : document;

        // Variant radios: fieldsets with data-option-name, checked radio gives value (picker can be outside form)
        const fieldsets = scope.querySelectorAll("fieldset[data-option-name]");
        fieldsets.forEach((fieldset) => {
          const optionName = fieldset.getAttribute("data-option-name");
          const checked = fieldset.querySelector('input[type="radio"]:checked');
          if (optionName && checked && checked.value) {
            options.push({ name: optionName, value: checked.value });
          }
        });

        // Variant selects: name="options[Option Name]", selected option gives value
        if (options.length === 0) {
          const selects = scope.querySelectorAll('select[name^="options["]');
          selects.forEach((select) => {
            const nameMatch = select.getAttribute("name") && select.getAttribute("name").match(/^options\[(.+)\]$/);
            const optionName = nameMatch ? nameMatch[1] : (select.previousElementSibling && select.previousElementSibling.textContent.trim()) || "Option";
            const selected = select.options[select.selectedIndex];
            if (optionName && selected && selected.value) {
              options.push({ name: optionName.trim(), value: selected.value });
            }
          });
        }

        return options;
      }

      setupQuantityInput() {
        if (!this.quantityInput || !this.quantityMinus || !this.quantityPlus) return;

        // Handle minus button
        this.quantityMinus.addEventListener("click", (e) => {
          e.preventDefault();
          const currentValue = parseInt(this.quantityInput.value) || 1;
          const minValue = parseInt(this.quantityInput.min) || 1;
          if (currentValue > minValue) {
            this.quantityInput.value = currentValue - 1;
            this.quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });

        // Handle plus button
        this.quantityPlus.addEventListener("click", (e) => {
          e.preventDefault();
          const currentValue = parseInt(this.quantityInput.value) || 1;
          this.quantityInput.value = currentValue + 1;
          this.quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
        });

        // Handle direct input
        this.quantityInput.addEventListener("change", () => {
          const value = parseInt(this.quantityInput.value) || 1;
          const minValue = parseInt(this.quantityInput.min) || 1;
          if (value < minValue) {
            this.quantityInput.value = minValue;
          }
        });
      }

      setupFormSubmission() {
        if (!this.form) return;

        this.form.addEventListener("submit", (e) => {
          e.preventDefault();
          this.formatAndSubmitForm();
        });
      }

      formatAndSubmitForm() {
        // Collect all form data
        const formData = new FormData(this.form);
        const quantity = this.quantityInput.value;
        const productName = this.querySelector("#quote-product-name-field").value;
        const variantId = this.querySelector("#quote-variant-id").value;
        const variantOptions = formData.get("contact[variant_options]");
        const name = formData.get("contact[name]");
        const company = formData.get("contact[company]");
        const email = formData.get("contact[email]");
        const phone = formData.get("contact[phone]");
        const country = formData.get("contact[delivery_country]");
        const details = formData.get("contact[other_details]");

        // Format message with all quote information
        let message = `Quote Request for Bulk Order\n\n`;
        message += `Product: ${productName}\n`;
        message += `Product ID: ${formData.get("contact[product_id]")}\n`;
        message += `Variant ID: ${variantId}\n`;
        if (variantOptions) message += `Variant: ${variantOptions}\n`;
        message += `Quantity Requested: ${quantity}\n\n`;
        message += `Contact Information:\n`;
        message += `Name: ${name}\n`;
        message += `Company: ${company}\n`;
        message += `Email: ${email}\n`;
        if (phone) message += `Phone: ${phone}\n`;
        message += `\nAdditional Information:\n`;
        if (country) message += `Delivery Country: ${country}\n`;
        if (details) message += `More Details: ${details}\n`;

        // Set the formatted message
        this.messageField.value = message;

        // Submit the form
        this.form.submit();
      }
    },
  );
  }
}

// Start defining the custom element
defineQuoteRequestDrawer();

// Handle Request Quote button clicks using event delegation
function handleQuoteRequestClick(e) {
  const button = e.target.closest('.quote-request-button');
  if (!button) return;

  e.preventDefault();
  e.stopPropagation();

  // Wait a bit to ensure drawer is available
  const drawer = document.querySelector('quote-request-drawer#QuoteRequestDrawer');
  if (!drawer) {
    console.warn('Quote request drawer not found, retrying...');
    // Retry after a short delay in case drawer hasn't loaded yet
    setTimeout(() => {
      const retryDrawer = document.querySelector('quote-request-drawer#QuoteRequestDrawer');
      if (retryDrawer) {
        retryDrawer.open(button);
        const drawerHeader = retryDrawer.querySelector('.drawer-header');
        if (drawerHeader && typeof trapFocus === 'function') {
          trapFocus(retryDrawer, drawerHeader);
        }
      } else {
        console.error('Quote request drawer still not found after retry');
      }
    }, 100);
    return;
  }

  drawer.open(button);
  const drawerHeader = drawer.querySelector('.drawer-header');
  if (drawerHeader && typeof trapFocus === 'function') {
    trapFocus(drawer, drawerHeader);
  }
}

// Setup event delegation on document
function setupQuoteRequestButtons() {
  // Use event delegation - attach to document so it works for dynamically added buttons
  document.addEventListener('click', handleQuoteRequestClick, true);
  
  // Also directly attach to existing buttons as a fallback
  const quoteButtons = document.querySelectorAll('.quote-request-button');
  quoteButtons.forEach((button) => {
    // Remove any existing listeners
    const newButton = button.cloneNode(true);
    button.parentNode?.replaceChild(newButton, button);
    
    newButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      handleQuoteRequestClick(e);
    });
  });
}

// Setup when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupQuoteRequestButtons);
} else {
  // DOM already loaded, setup immediately
  setupQuoteRequestButtons();
}

// Also setup buttons after dynamic content loads (for product page updates)
document.addEventListener('product:variant-change', setupQuoteRequestButtons);

// Setup buttons after a short delay to ensure everything is loaded
setTimeout(setupQuoteRequestButtons, 500);

